export default "__VITE_ASSET__C5_So$06__"